export default "__VITE_ASSET__Cm3ae19A__"